export enum Features {
  // RepeatOrder enabled based on BusinessLines
  RepeatOrder = 'repeatOrder',
  RepeatOrder_ADT = 'repeatActionBlkAdt',
  // CancelOrder enabled based on BusinessLines
  CancelOrder = 'cancelOrderv2',
  CancelOrder_RMX = 'cancelOrderv2RMX',
  CancelOrder_CEM = 'cancelOrderv2CEM',
  CancelOrder_AGG = 'cancelOrderv2AGG',
  CancelOrder_MLT = 'cancelOrderv2MLT',
  CancelOrder_ADT = 'cancelOrderv2ADT',
  // ModifyOrder enabled based on BusinessLines
  ModifyOrder = 'modifyOrder',
  ModifyOrder_ADT = 'modifyActionBlkAdt',

  ShowReqAndOrder = 'showReqAndOrderNumbers',
  EnableDownloadExcel = 'enableDownloadExcel',
  ON_HOLD_ORDER = 'OnHoldOrder',
  AdjustmentOrder = 'orderAdjustment',
  RmxAdditionalInfo = 'rmxAdditionalInfo',
  NeorisLogo = 'neorisLogo',
  TimeNegotiation = 'timeNegotiation',
  HideIndicativePrices = 'hideIndicativePrices',
  NewActionLogs = 'newActionLogs',
  IsOnlineOrder = 'isOnlineOrder',
  ShowUploadDocumentDropdownsFeature = 'showUploadDocumentDropdownsFeature',
  WalkMe = 'walkMe',
  PumpingService = 'pumpingService',
  ChatBotWizeline = 'chatBotWizeline',
  ChatBotAivo = 'chatBotAivo',
  ChatBotAivoRealocated = 'chatBotAivoRealocated',
  ReceiveMyProductsFromV3 = 'receiveMyProductsFromV3Endpoint',
  CatalogPCM = 'hybris',
  CreateReceivingPersonModalFeature = 'createReceivingPersonModalFeature',
  ShowTermsCheckboxOnUploadDocument = 'showTermsCheckboxOnUploadDocument',
  OrdersProductCatalogOrdersTab = 'ordersProductCatalogOrdersTab',
  OrdersProductCatalogSuggestedTab = 'ordersProductCatalogSuggestedTab',
  OrdersProductCatalogProductCatTab = 'ordersProductCatalogProductCatTab',
  OrdersProductCatalogFavoriteTab = 'ordersProductCatalogFavoriteTab',
  OrdersProductCatalogMyListTab = 'ordersProductCatalogMyListTab',
  LoadDefaultReceivingPerson = 'loadDefaultReceivingPerson',
  IsSalesReadonly = 'isSalesReadonly',
  CreatePodRequest = 'createPodRequest',
  LoadDefaultCatalogValues = 'loadDefaultCatalogValues',
  OrderActionMenu = 'orderActionMenu',
  RmsWay = 'rmsWay',
  ExtendedLogTab = 'extendedLogTab',
  AddNewProductOneClick = 'addNewProductOneClick',
  CalendarView = 'calendarView',
  LocationAndSpecification = 'locationAndSpecification',
  EnableActionLogV7 = 'enableActionLogV7',
  ENABLE_REPEAT_ARKIK = 'repeatArkik',
  BoomPump = 'boomPump',
  PurchaseOrderMaskValidation = 'purchaseOrderMaskValidation',
  HideMultiplePurchaseOrder = 'hideMultiplePurchaseOrder',
  CoBrowse = 'coBrowse',
  SimmaOnline = 'simmaOnline',
  ORDER_SUBSCRIPTION = 'orderSubscription',
  DCO_IMPROV = 'DCO_IMPROVEMENT',
  DcoWaitingListRedesign2025 = 'dcoWaitingListRedesign2025',
  AutomaticValidation = 'automaticValidation',
  EnableCounterofferMatchBulkCEM = 'enableCounterofferMatchBulkCEM',
  ReceivingPersonTestModifier = 'receivingPersonTestModifier',
  SMSSubscription = 'smsSubscription',
  SMSNotificationTestModifier = 'smsNotificationTestModifier',
  CalendarViewV2 = 'calendarView2',
  CalendarViewNewVersion = 'calendarViewNewVersion',
  EnableOrderAvailabilityExpirationTime = 'enableOrderAvailabilityExpirationTime',
  EnableOrderModificationExpirationTime = 'enableOrderModificationExpirationTime',
  EnablePODDropdownFeature = 'enablePODDropdown',
  ProductDescriptionHomologation = 'productDescriptionHomologation',
  ShowPodInsteadOfJobsiteFeature = 'showPodInsteadOfJobsiteFeature',
  EnabledBusinessDays = 'enabledBusinessDays',
  EnableSpecialScenariosMoo = 'enableSpecialScenariosMoo',
  EnableOdmOrderCreation = 'enableOdmOrderCreation',
  EnableContractDetail = 'enableContractDetail',
  EnableBusinessDaysCutOff = 'enableBusinessDaysCutOff',
  EnableAfterCutOffBulkCem = 'enableAfterCutOffBulkCem',
  SAME_DAY_MOO = 'sameDayMOO',
  ContractsExpirationDate = 'enableContractsExpirationDate',
  EnableSpacingValidationByQtyLoadSize = 'enableSpacingValidationByQtyLoadSize',
  ORDER_SUBSCRIPTION_MOO = 'orderSubscriptionMOO',
  EnablePODMooDropdownFeature = 'enablePODMooDropdownFeature',
  EnablePODDeleteMooFeature = 'enablePODDeleteMooFeature',
  EnablePODCreateOnModifyOrderFeature = 'enablePODModifyOrderFeature',
  EnablePODCreateOnRepeatOrderFeature = 'enablePODRepeatOrderFeature',
  RemoveContractFieldEnabled = 'removeContractFieldEnabled',
  ADD_RECEIVING_PERSON_MOO = 'addReceivingPersonMOO',
  RESTRICTED_JOBSITE_MOO = 'restrictedJobsiteMOO',
  CERTIFIED_TRUCKS_DRIVERS_MOO = 'certifiedTrucksDriversMOO',
  ORDER_MISSING_FIELDS_ALERT = 'orderMissingFieldsAlert',
  DELIVERY_INSTRUCTIONS_FIELD_MOO = 'deliveryInstructionsFieldMOO',
  TIME_FORMAT_BY_COUNTRY_UI = 'timeFormatByCountryUi',
  TIME_FORMAT_BY_LANG_UI = 'timeFormatByLangUi',
  TIME_FORMAT_BY_DEFAULT_UI = 'timeFormatByDefaultUi',
  DATE_FORMAT_BY_COUNTRY_UI = 'dateFormatByCountryUi',
  DATE_FORMAT_BY_LANG_UI = 'dateFormatByLangUi',
  DATE_FORMAT_BY_DEFAULT_UI = 'dateFormatByDefaultUi',
  DATE_FIRST_DAY_WEEK_BY_COUNTRY_UI = 'dateFirstDayWeekByCountryUi',
  DATE_FIRST_DAY_WEEK_BY_LANG_UI = 'dateFirstDayWeekByLangUi',
  DATE_FIRST_DAY_WEEK_BY_DEFAULT_UI = 'dateFirstDayWeekByDefaultUi',
  DELIVERY_TIME_WINDOW_SELECT = 'deliveryTimeWindowSelect',
  DELIVERY_TIME_PICKER = 'deliveryTimePicker',
  PAYMENT_TERMS = 'paymentTerms',
  LOAD_SIZE = 'loadSize',
  PALLETS_DEFAULT_UNIT_BAG_CEM = 'palletsDefaultUnitBagCem',
  SAME_DAY_ORDER = 'sameDayOrder',
  ORDER_DETAIL_LINK_MOO = 'orderDetailLinkMOO',
  SHOW_SPECIFICATION_MANEUVER = 'showSpecificationManeuver',
  PUMP_PRIMER = 'enableUnloadTypeAndPumpPrimer',
  ENABLE_ADMIXTURES_PRODUCT_TYPE = 'enableAdmixturesProductType',
  SHOW_ONE_DELIVERY_METHOD_FOR_ADMIXTURES = 'showOneDeliveryMethodForAdmixtures',
  DATE_AND_TIME_CTRL_BTNS_UI = 'buttonsOnDateAndTimePicker',
  TRUCKS_DRIVERS_CERTIFIED = 'trucksDriversCertified',
  CancelErrorHandling = 'cancelErrorHandling',
  CancelErrorHandlingTime = 'cancelErrorHandlingTimeV1',
  /**
   * Flag to send 'OOR' tag(when jobsite is at extended range) to the backend
   */
  ENABLE_OUT_RANGE_TAG = 'enableOutRangeTag',
  OUT_OF_SERVICE_HOURS = 'outOfServiceHours',
  CLOUD_CONTACT_MODULE = 'cloudContactModule',
  DELIVERY_BLOCKED = 'deliveryBlocked',
  ORDER_CANCEL_BUTTON = 'showCancelOrderButton',
  UNDER_RISK_COLORTAG = 'UnderRiskColorTag',
  /**
   * Flag to show only liters in order creation of admixtures
   */
  ENABLE_MULTIPLE_UNITS_IN_ADMIXTURES = 'enableMultipleUnitsInAdmixtures',

  /**
   * Enable the feature to restrict the load size and volume based on the calendar API response
   */
  RESTRICTED_LOAD_SIZE_AND_VOLUME = 'enableRestrictedLoadSizeAndVolume',
  NEW_ORDER_AFTER_CUT_OFF = 'newOrderAfterCutOff',
  /**
   * Enable the feature to show collections in product list for Admixtures Mexico
   */
  CALL_ACTIONS_BLK_ADT = 'callActionsBlkAdt',
  /**
   * Check if particular feature is active in Order actions menu like cancel | repeat | modify
   */
  // TODO: This Action must be moved into `RepeatOrder_ADT`
  REPEAT_ACTION_BLK_ADT = 'repeatActionBlkAdt',
  // TODO: This Action must be moved into `CancelOrder_ADT`
  CANCEL_ACTION_BLK_ADT = 'cancelActionBlkAdt',
  // TODO: This Action must be moved into `ModifyOrder_ADT`
  MODIFY_ACTION_BLK_ADT = 'modifyActionBlkAdt',

  ORDER_LIST_ICON_ACTIONS_MENU = 'orderListIconActionsMenu',

  NEXT_BUSINESS_DAY_PRE_SELECTION = 'nextBusinessDayPreSelection',
  ORDER_CONFIRM_TO_DISPATCH = 'orderConfirmToDispatch',
  JOBSITE_RESTRICTED = 'jobSiteRestricted',
  // Feature to enable cash order
  CASH_ORDER_BLK_ADT = 'cashOrderBlkAdt',

  // Feature to enable jobsite dropdown in repeat order.
  ENABLED_JOBSITE_DROPDOWN_REPEAT_ORDER = 'enabledJobsiteDropdownRepeatOrder',

  ENABLE_POD_FILTER = 'enablePodFilter',

  // Feature to enable default time in Multiple Order on Adding mix
  DEFAULT_TIME_ADD_MOO = 'defaultTimeAddMOO',

  // Feature to enable default time in Multiple Order on Duplicate
  DEFAULT_TIME_DUPLICATE_MOO = 'defaultTimeDuplicateMOO',

  // Feature to enable auto select jobsite in Multiple Order
  AUTO_SELECT_JOBSITE_MOO = 'autoSelectJobsiteMOO',

  // Feature to enable DCO LOGS STATISTICS Version 2
  DCO_LOGS_STATISTICS = 'dcoLogsStatistics',

  // Feature to enable set non working days in day picker when duplicating multiple order
  SET_NON_WORKING_DAYS_PICKER_MOO = 'setNonWorkingDaysPickerMOO',
  // Feature to enable new map for VL create new JS
  ENABLED_SECOND_MAP_CREATE_JOBSITE = 'enabledSecondMapCreateJobsite',

  /**
   * Flag to enable new modification rules for orders
   */
  IMPROVEMENTS_MODIFY_ORDER_RULES = 'improvementsModifyOrderRules',

  // Flag to enable or disable message of credit exceeded for Colombia
  CREDIT_LIMIT_EXCEEDED_MESSAGE = 'creditLimitExceededMessage',
  /**
   * Flag to use API for admixture lead time
   */
  LEAD_TIMES_API_BLK_ADT = 'leadTimesApiBlkAdt',

  /**
   * Feature to enable the new action logs multi product for the order detail page
   */
  ACTION_LOGS_V7_MULTI_PRODUCT = 'actionLogsV7MultiProduct',

  /**
   * Feature to enable the Unload Type and Application Catalogues Homologation
   */
  UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION = 'unloadTypeAndApplicationCataloguesHomologation',
  /**
   * Flag to enable/disable default "Role" for newly created receiving person
   */
  HIDE_ROLE_RECEIVING_PERSON = 'hideRoleReceivingPerson',
  // Feature to disable receiving person prefill in order subscription
  DISABLE_EMAIL_RECEIVING_PERSON_PREFILL = 'disableEmailReceivingPersonPrefill',
  DISABLE_COMMENTS_RMX = 'disableCommentsRMX',

  /*
   * Flag to enable ODM order creation for admixtures
   */
  ODM_ORDER_CREATION_BLK_ADT = 'odmOrderCreationBlkAdt',

  // Feature to enable the multiple orders prefill functionality
  PREFILL_MOO = 'prefillMoo',

  /**
   * Flag to enable/disable experience check for Prefill MO feature
   */
  PREFILL_MO_IGNORE_EXPERIENCE_CHECK = 'prefillMoIgnoreExperienceCheck',

  /**
   * Flag to enable/disable project profiles field
   */
  PROJECT_PROFILES = 'projectProfiles',
  /**
   * Flag to determine if order quantity on Calendar page
   * should be taken from order.totalQuantity value (false) or
   * calculated as a sum of order products quantities (true)
   */
  COUNT_ORDER_QUANTITY_FROM_PRODUCTS = 'countOrderQuantityFromProducts',

  /**
   * Flag to enable/disable scenarios for orders with rejection code
   */
  ORDER_REJECTION_CODE = 'orderRejectionCode',

  /**
   * Flag to hide additional info field
   * If "true" then additional field will be hidden
   * If "false" then additional field will be shown
   */
  ADDITIONAL_INFO = 'additionalInfo',

  NEW_ORDER_FLOW = 'newOrderFlow',
  DCO_TIME_EXPIRATION_MOO = 'DCOTimeExpirationMOO',

  /**
   * In special scenario for specific countries calculate availability for modify/cancel order
   */
  ENABLE_CALCULATION_AVAILABILITY_DATE = 'enableCalculationAvailabilityDate',
  ENABLE_CALCULATION_AVAILABILITY_DATE_FOR_CANCEL = 'enableCalculationAvailabilityDateForCancel',
  ENABLE_CALCULATION_AVAILABILITY_DATE_FOR_MODIFY = 'enableCalculationAvailabilityDateForModify',

  /**
   * Flag to enable/disable cleanUp field in the component from config
   */
  CLEAN_UP = 'cleanUp',

  /**
   * Flag to enable/disable improvements for smart suggestion
   * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-10866
   */
  PREFILL_MOO_IMPROVEMENTS_ALL_WEEKS = 'prefillMooImprovementsAllWeeks',

  /**
   * Flag to enable/disable calendar view order card changes for EMEA region
   * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-7739
   */
  EMEA_CALENDAR_VIEW_IMPROVEMENTS = 'emeaCalendarViewImprovements',

  /**
   * Flag to disabling/enabling showing full address in the jobsite/pod selector
   * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-10381
   */
  NOF_JOBSITE_FULL_ADDRESS = 'nofJobsiteFullAddress',

  /**
   * Flag to disabling/enabling showing multiple locations tag in the jobsite/pod selector
   * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-10381
   */
  NOF_JOBSITE_MULTIPLE_LOCATIONS = 'nofJobsiteMultiLocations',

  /**
   * Hide the Back button from Step 5 to Step 4 in the order creation summary
   * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-10381
   */
  HIDE_BACK_BUTTON_FROM_LAST_STEP = 'hideBackButtonFromLastStep',

  /**
   * Flag to disabling/enabling showing custom spacing in selectors for orders from omnichannel for offline orders
   * @see https://cemexpmo.atlassian.net/browse/CX030GO2103-18746
   */
  CUSTOM_SPACING = 'customSpacing',

  /**
   * Flag to enable/disable the new varios location
   * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-7739
   */
  ENABLE_VARIOUS_LOCATION_V4 = 'enabledVariousLocationV4',
  /**
   * Flag to handle errors in inputs/selects on touched and not on STATUS change
   */
  FORM_ERROR_HANDLING_ON_TOUCHED = 'formErrorHandlingOnTouched',

  /**
   * Flag to enable/disable action for modifying Arkik orders
   */
  ENABLE_MODIFY_ARKIK = 'enableModifyActionArkik',

  /**
   * Flag to enable/disable the new pod creation for Arkik orders
   */
  ENABLE_NEW_POD_ARKIK = 'enableNewPodArkik',

  /**
   * Flag to hide unloadTime from order detail screen
   */
  HIDE_UNLOAD_TIME = 'hideUnloadTime',

  /**
   * Flag to enable/disable logistic charges messages
   */
  LOGISTIC_CHARGES = 'logisticCharges',

  /**
   * Flag to include modified fields in modify payload
   */
  MODIFIED_FIELDS_ARKIK = 'modifiedFieldsArkik',

  /**
   * Flag to enable/disable building materials feature
   */
  ENABLE_BUILDING_MATERIALS = 'enableBuildingMaterials',

  /**
   * Flag to enable the validation of the contract balance when creating an order.
   */
  AGREEMENT_BALANCE_VALIDATION = 'agreementBalanceValidation',

  /**
   * Flag to enable/disable order analytics for USA
   */
  ORDER_ANALYTICS_US = 'orderAnalyticsUS',

  /**
   * Flag to enable receiving person synchronization feature
   */
  RECEIVING_PERSON_SYNCHRONIZATION = 'receivingPersonSynchronization',
}
